import Auth from './auth.js'
import Api from './lib/api.js';
import DlgPrivacy from './lib/privacy.js'
import IVPLoader from './lib/loader.js'


document.addEventListener("DOMContentLoaded",async()=>{

    document.querySelector("#sidebar-menu .contractors").classList.add("active")
    document.querySelector(".navbar-header .breadcrumb").append($(`<li class="breadcrumb-item active">Contractors</li>`)[0])

    IVPLoader.Show()

    await Auth.Init()

    if (Auth.user.privacy_accepted == false)
        await DlgPrivacy.EnsureAccepted()

    // Default Datatable
    let resp = await Api.GetContractors()
    let btb = $('#basic-datatable').DataTable({
        "pageLength": 50,
        "language": {
            "paginate": {
                "previous": "<i class='mdi mdi-chevron-left'>",
                "next": "<i class='mdi mdi-chevron-right'>"
            },
            processing:     "Elaborazione dati...",
            search:         "Ricerca&nbsp;:",
            lengthMenu:    "Visualizza _MENU_ record",
            info:           "Visualizzati da _START_ a _END_ di _TOTAL_ record",
            infoEmpty:      "Nessun record in archivio",
            infoFiltered:   "(trovati su _MAX_ in totale)",
            infoPostFix:    "",
            loadingRecords: "Caricamento dati...",
            zeroRecords:    "Nessun record",
            emptyTable:     "Archivio vuoto",
            sortAscending:  ": activer pour trier la colonne par ordre croissant",
            sortDescending: ": activer pour trier la colonne par ordre décroissant"
        },
       /* 
        "name": "AYME GROUP SRL",
        "address": "Viale Abruzzi 13/A  ",
        "zip": "20131",
        "city": "MILANO",
        "province": "MI",
        "vat": "10721330966",
        "email": "aymegroupsrl2019@gmail.com",
        "pec": "aymegroupsrl@pec.it",
        "phone": "393425017635",
        "iban": "IT46P0760111700001061575989",
        "sdi_code": "N92GLON",
        "auth_id": 54,
        "privacy_accepted": null,
        "login": "aymegroupsrl@pec.it",
        "secret": "12345"
        */
        columns: [                        
            { title: 'Nome', data: 'name' },
            { title: 'Indirizzo', data: 'address' },
            { title: 'Città', data: 'city' },
            //{ title: 'Cap', data: 'zip' },
            //{ title: 'Importo', data: 'amount' },          
            { title: 'Telefono', data: 'phone' },
            //{ title: 'Email', data: 'email' },
            { title: 'Login', data: 'login' },
            { title: ' ', data: '' },
        ],
        columnDefs: [
            {   
                targets: [-1],
                render: function (data, type, row) {
                    return "<button type='button' class='btnEdit btn btn-outline-secondary btn-sm'>Modifica</button>";   
                },
                
            },
        ],
        data: resp
    });

    let fnEdit = ()=> {
        $("#basic-datatable .btnEdit").off('click')
        $("#basic-datatable .btnEdit").click((e)=>{
            let tr = btb.row(e.target.closest('tr'))
            document.location.href = "contractor.html?id="+tr.data().id
            console.log(tr.data())
        })
    }

    fnEdit()
    
    btb.on( 'draw init.dt', fnEdit)

    IVPLoader.Remove()
})